(ns bec-core.cljs.config
  (:require [bec-cljs-common.core :as bcc.core]))


(bcc.core/init! "bec-core" "bec-core-client" "../bec-core-server" [:bec-core-server] "bec-core-client")


(defn get-bec-core-server-url []
  "../bec-core-server")
